
import { useCallback } from "react"
import NumberPicker from 'app/inputs/NumberPicker'

export default ({ onChange, value, step = 1, ...props }) => {
  const onUp = useCallback(() => {
    onChange(value + step)
  })

  const onDown = useCallback(() => {
    onChange(value - step)
  })

  return <NumberPicker { ...props } up={ onUp }  down={ onDown } />
}
